<template>
    <b-modal
        :active="active"
        @close="close()">
        <form @submit.prevent="save()">
            <div class="modal-card" style="width: auto">
                <header class="modal-card-head">
                    <p class="modal-card-title">
                        Редактирование роли
                    </p>
                </header>
                <section class="modal-card-body">

                    <b-field grouped>
                        <b-field label="Название" expanded>
                            <b-field>
                                <b-input
                                    placeholder="Название"
                                    :value="role.title"
                                    disabled
                                    expanded>
                                </b-input>
                            </b-field>
                        </b-field>
                    </b-field>

                    <div class="field is-grouped-multiline">
                        <label class="label">Привилегии</label>
                        <div class="tags">
                            <div class="tag"
                                v-for="permission of role.permissions"
                                :key="permission.id">
                                {{ permission.name }}
                            </div>
                        </div>
                    </div>

                    <div class="field is-grouped-multiline"
                        v-if="Object.keys(role.scope_rules || {}).length > 0">
                        <label class="label">Ограничения области применения</label>
                        <div class="control">
                            <div class="columns"
                                v-for="(scope, index) in scopes"
                                :key="index">
                                <div class="column">
                                    <template v-for="s in scope">
                                        <b-field
                                            expanded
                                            :label="$t(`roles.scopes.${s.name}.title`)"
                                            :addons="false"
                                            :key="`${s.name}[${index}]:label`">
                                            <div class="columns"
                                                v-for="(model, j) in s.model"
                                                :key="`${s.name}[${index}][${j}]:field`">
                                                <div class="column">
                                                    <scope-field
                                                        :user-preset="user"
                                                        :value="model"
                                                        @input="value => updateScope([index, s.name, j], value)"
                                                        :rule="s.rule"
                                                        :name="s.name">
                                                    </scope-field>
                                                </div>
                                                <div class="column is-narrow">
                                                    <div
                                                        @click="removeScopeItem([index, s.name, j])"
                                                        class="button is-outlined"
                                                        style="height: 100%">
                                                        <span class="icon">
                                                            <i class="mdi mdi-close"></i>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                @click="addScopeItem([index, s.name])"
                                                class="button is-fullwidth">
                                                <span class="icon">
                                                    <i class="mdi mdi-plus"></i>
                                                </span>
                                                <span v-if="s.model.length > 0">
                                                    Расширить ограничение
                                                </span>
                                                <span v-else>
                                                    Добавить ограничение
                                                </span>
                                            </div>
                                        </b-field>
                                    </template>
                                </div>
                                <div class="column is-narrow">
                                    <div
                                        @click="removeScope(index)"
                                        class="button is-danger is-outlined"
                                        style="height: 100%">
                                        <span class="icon">
                                            <i class="mdi mdi-delete"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="button is-fullwidth"
                                @click="addScope">
                                <span class="icon">
                                    <i class="mdi mdi-plus"></i>
                                </span>
                                <span>Добавить ограничение</span>
                            </div>
                            <br>
                        </div>
                    </div>

                </section>
                <footer class="modal-card-foot">
                    <button
                        @click="close()"
                        class="button"
                        type="button">
                        Закрыть
                    </button>
                    <button
                        class="button is-primary">
                        Сохранить
                    </button>
                </footer>
            </div>
        </form>
    </b-modal>
</template>

<script>
import BaseModal from "../BaseModal";
import ScopeField from "./ScopeField";

export default BaseModal.extend({
  data() {
    return {
      scopes: [],
      user: {},
      role: {
        permissions: []
      }
    };
  },
  components: { ScopeField },
  methods: {
    clearScope() {
      this.scopes = [];
    },
    addScope(data) {
      let scope = [];

      for (let name in this.role.scope_rules) {
        let rule = this.role.scope_rules[name];

        let model = [];

        if (data[name]) {
          model = data[name];
        }

        scope.push({
          rule,
          name,
          model
        });
      }

      this.scopes.push(scope);
    },
    removeScope(index) {
      this.scopes.splice(index, 1);
    },
    convertScopePath(path) {
      let index = _.findIndex(this.scopes[path[0]], { name: path[1] });
      if (index > -1) {
        let result = [path[0], index, "model"];

        if (path[2] !== undefined) {
          result.push(path[2]);
        }

        return result;
      }
    },
    updateScope(path, value) {
      let originalPath = path;
      path = this.convertScopePath(path);

      if (path) {
        _.set(this.scopes, path, value);
      }
    },
    addScopeItem(path) {
      path = this.convertScopePath(path);

      if (path) {
        _.get(this.scopes, path).push(null);
      }
    },
    removeScopeItem(path) {
      path = this.convertScopePath(path);

      if (path) {
        _.get(this.scopes, path.slice(0, path.length - 1)).splice(
          path[path.length - 1],
          1
        );
      }
    },
    compileScope() {
      let result = [];

      for (let scopes of this.scopes) {
        result.push({});

        let last = _.last(result);

        for (let scope of scopes) {
          last[scope.name] = _.reject(scope.model, _.isNull);
        }
      }

      return result;
    },
    async open(user, role) {
      this.user = user;

      await this.$helpers
        .load(axios.get(`/api/users/${user.id}/roles/${role.id}`))
        .then(({ data }) => {
          this.role = data;
          this.clearScope();

          for (let scope of data.scope) {
            this.addScope(scope);
          }
        })
        .catch(error => {
          this.$emit("error", error);
        });

      this.show();
    },
    close() {
      this.hide();
    },
    save() {
      this.$helpers
        .load(
          axios.put(`/api/users/${this.user.id}/roles/${this.role.id}`, {
            scope: this.compileScope()
          })
        )
        .then(response => {
          this.$emit("saved", response.data);
        })
        .catch(error => {
          this.$emit("error", error);
        });
    }
  }
});
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/modals/roles/AssignmentEdit.vue